import { mapState } from 'vuex'

import { ApplicationHelper } from '@/helpers/Application'
import { ChatHelper } from '@/helpers/Chat'
import {
  EVENT_CHAT_CLOSE,
  EVENT_CHAT_LOADED,
  EVENT_CHAT_NUDGING,
  EVENT_CHAT_OPEN,
  EVENT_LANGUAGE_CHANGED,
  CUSTOM_EVENT_CHAT_BASKET_UPDATED,
  CUSTOM_EVENT_CHAT_CONVERSATION_ENDED,
  CUSTOM_EVENT_CHAT_CONVERSATION_STARTED,
  CUSTOM_EVENT_CHAT_CLOSE,
  CUSTOM_EVENT_CHAT_LANGUAGE,
  CUSTOM_EVENT_CHAT_OPEN,
  CUSTOM_EVENT_CHAT_TRIGGER_NUDGING,
} from '@/config/events'

let initialized = false

//const parse = (location) => import('url-parse').then(parser => parser.default(location.href, true))

export default {
  data() {
    return {
      chatOpen: false,
      chatConversation: false,
      chatTriggered: false,
    }
  },

  created() {
    if (!initialized && process.env.VUE_APP_FEATURE_CHAT) {
      initialized = true

      this.initializeChat()
        .then(() => this.$_chatAddEventDispatcher())
        .then(() => this.$_chatAddEventListener())
        .then(() => {
          ApplicationHelper.dispatchCustomEvent(CUSTOM_EVENT_CHAT_LANGUAGE, {
            language: this.$i18n.locale,
          })

          if (this.chatOpen) {
            this.openChat()
          }
        })
        .finally(_ => {
          this.$EventBus.$emit(EVENT_CHAT_LOADED, initialized)
        })
    }
  },

  computed: {
    ...mapState(['basket']),
  },

  methods: {
    initializeChat() {
      return (
        ApplicationHelper.pendingHTML('.sanchat-wrapper')
          .then(_ => (initialized = true))
          // ON production we disable the chat if it not loaded
          .catch(_ => (initialized = process.env.NODE_ENV === 'development'))
      )
    },

    openChat(options) {
      if (initialized) {
        const eventOptions = options ?? { behavior: 'active' }
        ApplicationHelper.dispatchCustomEvent(CUSTOM_EVENT_CHAT_OPEN, eventOptions)
      }
    },

    $_chatAddEventDispatcher() {
      this.$EventBus.$on(EVENT_CHAT_OPEN, event => {
        this.chatOpen = true
        this.openChat(event)
      })

      this.$EventBus.$on(EVENT_CHAT_NUDGING, () => {
        if (!this.chatTriggered) {
          this.chatTriggered = true
          ApplicationHelper.dispatchCustomEvent(CUSTOM_EVENT_CHAT_TRIGGER_NUDGING)
        }
      })

      this.$EventBus.$on(EVENT_LANGUAGE_CHANGED, ({ language }) => {
        ApplicationHelper.dispatchCustomEvent(CUSTOM_EVENT_CHAT_LANGUAGE, {
          language,
        })
      })

      return Promise.resolve()
    },

    $_chatAddEventListener() {
      const listenTo = window.addEventListener

      // start sending basket to chat app
      listenTo(CUSTOM_EVENT_CHAT_CONVERSATION_STARTED, () => {
        // send basket to chat app
        ApplicationHelper.dispatchCustomEvent(CUSTOM_EVENT_CHAT_BASKET_UPDATED, ChatHelper.getChatBasket(this.basket))
        this.chatConversation = true
      })

      // emit close event on chat closing
      listenTo(CUSTOM_EVENT_CHAT_CLOSE, () => {
        this.chatOpen = false
        this.$EventBus.$emit(EVENT_CHAT_CLOSE)
      })

      // disable watcher if chat is closed
      listenTo(CUSTOM_EVENT_CHAT_CONVERSATION_ENDED, () => {
        this.chatConversation = false
      })

      return Promise.resolve()
    },
  },

  watch: {
    basket: {
      deep: true,
      handler(basket) {
        if (this.chatConversation) {
          ApplicationHelper.dispatchCustomEvent(CUSTOM_EVENT_CHAT_BASKET_UPDATED, ChatHelper.getChatBasket(basket))
        }
      },
    },
  },
}
